import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SuperAdminService } from '../../services/super-admin/super-admin.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';
import { SaAddUserDialogComponent } from './sa-add-user-dialog/sa-add-user-dialog.component';
import { ManageUserDialogComponent } from '../establishment-staff/manage-user-dialog/manage-user-dialog.component';
import { superAdminUserAccessApi } from './sa-user-access-api';

// Super admin: every user of the platform. Manage opens the same roles-and-
// permissions dialog the establishment Manage Users screen uses, backed by the
// super-admin API (any role, central or at any establishment).
@Component({
  selector: 'app-sa-users',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './sa-users.component.html',
  styleUrls: ['./sa-users.component.scss', '../../../common-style/admin-list-page.scss'],
})
export class SaUsersComponent implements OnInit {
  users: any[] = [];
  isLoading: boolean = false;
  search = new FormControl('');

  constructor(
    private superAdminService: SuperAdminService,
    private toastService: ToastService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.superAdminService.listUsers().subscribe({
      next: (res: any) => {
        this.users = res?.data?.users || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.users = [];
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load users.');
      },
    });
  }

  // top-right search: name, username, mobile or role
  filteredUsers(): any[] {
    const term = (this.search.value || '').trim().toLowerCase();
    if (!term) return this.users;
    return this.users.filter((u) =>
      `${u.fullName} ${u.userName} ${u.mobileNumber || ''} ${u.roles || ''}`.toLowerCase().includes(term)
    );
  }

  addUser(): void {
    const ref = this.dialog.open(SaAddUserDialogComponent, { width: '640px', maxWidth: '95vw' });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.load();
    });
  }

  toggleRestricted(user: any): void {
    if (user.isSelf) return;
    this.isLoading = true;
    this.superAdminService.setUserRestricted(user.sumId, !user.isRestricted).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Updated.');
        this.load();
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to update user.');
      },
    });
  }

  manage(user: any): void {
    const ref = this.dialog.open(ManageUserDialogComponent, {
      width: '900px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100dvh - 32px)',
      data: { sumId: user.sumId, name: user.fullName, api: superAdminUserAccessApi(this.superAdminService) },
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.load();
    });
  }
}
